"use client";

// Гейт консольных экранов портала. Гость уходит в Passport-флоу с
// redirect_target на текущий origin (st2-state, SSO 2.1); после логина
// сервер вернёт его на этот origin в /auth/callback с токенами.
//
// Прод-баг (исправлено): ссылка входа строилась из пустого стора конфига
// — на портале нет use-app-init, наполняющей oauth_client_id. Теперь
// конфиг гарантируется ДО построения ссылки; если его не достать —
// человеческая ошибка вместо редиректа в пустоту.
import { useEffect, useState } from "react";

import { isAuthenticated } from "@/lib/auth";
import { resolveDevLoginUrl } from "@/lib/dev-host";
import { useTranslation } from "@/lib/i18n";

export function DevAuthGate({
  children,
  redirect = (url: string) => window.location.replace(url),
}: {
  children: React.ReactNode;
  redirect?: (url: string) => void;
}) {
  const t = useTranslation();
  const [checked, setChecked] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (isAuthenticated()) {
      setChecked(true);
      return;
    }
    let alive = true;
    resolveDevLoginUrl(window.location.origin + window.location.pathname)
      .then((url) => {
        if (alive) redirect(url);
      })
      .catch(() => {
        if (alive) setFailed(true);
      });
    return () => {
      alive = false;
    };
  }, [redirect]);

  if (failed) {
    return (
      <p className="text-sm text-m-error">{t("dev.login.failed")}</p>
    );
  }
  if (!checked) return null;
  return <>{children}</>;
}
